import {
    ADD_REMOTE_USER, OPEN_REMOTE_REPORTS_MODAL, REMOVE_REMOTE_USER,
} from './actionTypes'

export const addRemoteUser = payload => ({
    type: ADD_REMOTE_USER,
    payload,
})
export const removeRemoteUser = payload => ({
    type: REMOVE_REMOTE_USER,
    payload,
})

export const isModalRemoteReportsModal = payload => ({
    type: OPEN_REMOTE_REPORTS_MODAL,
    payload,
})
